import Axios from 'axios';
// import { Message } from "element-ui";
import VM from '@/main';
import { Indicator } from 'mint-ui';

// 配置默认参数
const instance = Axios.create({
  baseURL: './api/v2/',
  timeout: 5000,
  headers: { }
});

// 添加请求拦截器
instance.interceptors.request.use(config => {
    const { userInfo } = VM.$store.state;
    Indicator.open();
    if ( userInfo ) {
      const Authorization = `Bearer ${userInfo.token}`;
      config.headers.Authorization = Authorization;
    }
    const { url } = config;
    url.includes('/api/') && (config.baseURL = '');
    return config;
  }, error => {
    // 对请求错误做些什么
    return Promise.reject(error);
  });

// 添加响应拦截器
instance.interceptors.response.use(res => {
  // 请求响应
  const { data, headers } = res;
  const { error } = data;
  Indicator.close();
  // 如果有新的token，更新token
  if ( 'authorization' in headers ) {
    const token = headers.authorization.replace(/Bearer /, "");
    VM.updateUserInfo({ token });
  }
  // 错误提示
  if ( error ) {
    const isStr = typeof error === 'string';
    VM.$toast(isStr ? error : error.toString())
    return Promise.reject(res);
  }
  return data;
}, error => {
  // token失效，指向登录
  const { status } = error.response;
  if ( status === 401 ) {
    const { name } = VM.$route;
    if ( name !== 'login' ) {
      VM.$router.push({ name: 'login' });
      return;
    } else {
      VM.$toast('用户名或密码有误！请检查。');
    }
  }
  // 对响应错误做点什么
  return Promise.reject(error);
});
export default {
  install(Vue) {
    Vue.prototype.$axios = instance;
  },
  instance
};
